__turbopack_context__.v({
  "cta": "text-cta-module-scss-module__oJ8iVG__cta",
  "icon": "text-cta-module-scss-module__oJ8iVG__icon",
  "inline": "text-cta-module-scss-module__oJ8iVG__inline",
  "placeholder": "text-cta-module-scss-module__oJ8iVG__placeholder",
  "plain": "text-cta-module-scss-module__oJ8iVG__plain",
  "slim": "text-cta-module-scss-module__oJ8iVG__slim",
  "text": "text-cta-module-scss-module__oJ8iVG__text",
  "thin": "text-cta-module-scss-module__oJ8iVG__thin",
});
